export default {

	/*
	async page_list () {

		const res = await Anvil.REST.get('/c_order/terminal/structured_list')
		await Anvil.renderPage('/c_order/terminal/page_list', { list: { data: res.companies } })
	},

	async action_refresh () {

		const grid = Anvil.models.components.Grid.find('#company_grid')
		if (grid) {
			const res = await Anvil.REST.get('/c_order/terminal/structured_list')
			const list = { data: res.companies }

			Anvil.page.list = list
			grid.list = list
		}
	},
	*/

	async page_list_old () {

		const [ terminals, company_groups, versions ] = await Promise.all([
			Anvil.models.c_order.TerminalList.fetch(),
			Anvil.models.CompanyGroupList.fetch(),
			Anvil.models.c_order.Versions.fetch()
		])

		const search = new Anvil.models.Record({
			archive: '0',
			company_group_id: null
		})

		await Anvil.renderPage('/c_order/terminal/page_list_old', { terminals, company_groups, versions, search })
	},

	async page_list (params) {

		const [ terminals, company_groups, versions, companies ] = await Promise.all([
			Anvil.models.c_order.TerminalList.fetch(),
			Anvil.models.CompanyGroupList.fetch(),
			Anvil.models.c_order.Versions.fetch(),
			Anvil.models.CompanyList.fetch()
		])

		const search = new Anvil.models.Record({
			sort_order: params.sort_order || '',
			expression: params.expression || '',

			// Additional search parameters
			archive: params.archive || '0',
			company_group_id: params.company_group_id || null,
			referer_id: params.referer_id || null,
			distributor_id: params.distributor_id || null,
			platform: params.platform || null,
			update_channel: params.update_channel || null,
			bct_driver: params.bct_driver || null
		})

		await Anvil.renderPage('/c_order/terminal/page_list', { terminals, company_groups, versions, companies, search })
	},

	async page_list_2 () {

		const [ company_groups, companies, company_dbs, sites, storages, terminals, versions ] = await Promise.all([
			Anvil.models.CompanyGroupList.fetch(),
			Anvil.models.CompanyList.fetch(),
			Anvil.models.c_order.CompanyDBList.fetch(),
			Anvil.models.c_order.SiteList.fetch(),
			Anvil.models.c_order.StorageList.fetch(),
			Anvil.models.c_order.TerminalSimpleList.fetch(),
			Anvil.models.c_order.Versions.fetch()
		])

		for (const company_group of company_groups.data) {
			company_group.companies = []
		}

		for (const company of companies.data) {
			const company_group = company_groups.getById(company.group_id)
			if (company_group) {
				company_group.companies.push(company)
			}
			company.company_dbs = []
		}

		for (const company_db of company_dbs.data) {
			const company = companies.getById(company_db.company_id)
			if (company) {
				company.company_dbs.push(company_db)
			}
			company_db.sites = []
		}

		for (const site of sites.data) {
			const company_db = company_dbs.getById(site.company_db_id)
			if (company_db) {
				company_db.sites.push(site)
			}
			site.storages = []
		}

		for (const storage of storages.data) {
			console.log(storage.company_db_id, storage.site_id)
			const site = sites.getById(storage.company_db_id, storage.site_id)
			if (site) {
				site.storages.push(storage)
			}
			storage.terminals = []
		}

		for (const terminal of terminals.data) {
			const storage = storages.getById(terminal.company_db_id, terminal.storage_id)
			if (storage) {
				storage.terminals.push(terminal)
			}
		}

		const search = new Anvil.models.Record({
			company_group_id: null
		})

		await Anvil.renderPage('/c_order/terminal/page_list_2', { company_groups, companies, company_dbs, sites, storages, terminals, versions, search })
	},

	async action_refresh () {

		const [ terminals, company_groups ] = await Promise.all([
			Anvil.models.c_order.TerminalList.fetch(),
			Anvil.models.CompanyGroupList.fetch()
		])

		Anvil.page.terminals = terminals
		Anvil.page.company_groups = company_groups
		const grid = Anvil.models.components.Grid.find('#terminal_grid')
		if (grid) {
			grid.list = terminals
		}
	},

	async modal_edit (company_id, machine_id) {

		const [ terminal, instructions, debits, debit_types ] = await Promise.all([
			Anvil.models.c_order.Terminal.fetch(machine_id),
			Anvil.REST.get(`/c_order/terminal/${machine_id}/instructions`),
			Anvil.REST.get(`/c_order/debit/list/${company_id}/terminal/${machine_id}`),
			Anvil.models.c_order.DebitTypeList.fetch(),
		])

		// Add debit records
		terminal.recurring_debits = []
		terminal.one_time_debits = []
		for (const debit of debits) {
			if (debit.start_d) debit.start_d = Anvil.moment(debit.start_d).format('YYYY-MM-DD')
			if (debit.end_d) debit.end_d = Anvil.moment(debit.end_d).format('YYYY-MM-DD')
			if (debit.recurring) {
				terminal.recurring_debits.push(new Anvil.models.c_order.RecurringDebit(debit))
			} else {
				terminal.one_time_debits.push(new Anvil.models.c_order.OneTimeDebit(debit))
			}
		}

		const instruction_form = new Anvil.models.Record({ code: '' })

		await Anvil.modal('/c_order/terminal/modal_edit', { terminal, debits, debit_types, instructions, instruction_form })
	},

	async action_enqueue_instruction (instruction) {

		$('#enqueue-instruction-btn').prop('disabled', true)
		const machine_id = Anvil.page.modal.terminal.machine_id

		// Insert instruction
		const res = await Anvil.REST.post(`/c_order/terminal/${machine_id}/instructions`, { instruction })

		this.refresh_instructions()

		Anvil.toast.success('Feladva', 'A script sikeresen sorba lett állítva a terminálra küldéshez.')
		$('#enqueue-instruction-btn').prop('disabled', false)
	},

	async refresh_instructions () {

		const machine_id = Anvil.page.modal.terminal.machine_id

		// Fetch new instruction list
		const instructions = await Anvil.REST.get(`/c_order/terminal/${machine_id}/instructions`)
		Anvil.page.instructions = instructions

		// Re-render instruction list
		Anvil.render('/c_order/terminal/panel_instructions', { instructions }, '#terminal-tab-instructions-log')
	},

	async action_save (terminal) {

		// Tell the record to commit
		await terminal.record.commit()

		Anvil.toast.success('Elmentve', 'A terminál mentése sikeres')

		// Refresh list
		await this.action_refresh()

		// Focus on company
		const grid = Anvil.models.components.Grid.find('#terminal_grid')
		if (grid) {
			grid.select(grid.list.data.find(c => c.machine_id == terminal.machine_id), true)
		}

		return true
	},

	async page_map () {

		const [ sites, storages, terminals ] = await Promise.all([
			Anvil.REST.get('/c_order/site/list'),
			Anvil.REST.get('/c_order/storage/list'),
			Anvil.REST.get('/c_order/terminal/list')
		])

		for (const site of sites) {
			site.storages = []
			site.aps = []
		}

		for (const storage of storages) {
			storage.terminals = []
			storage.aps = []
			const site = sites.find(s => s.company_db_id == storage.company_db_id && s.id == storage.site_id)
			if (site) {
				site.storages.push(storage)
			}
		}

		for (const terminal of terminals) {
			const storage = storages.find(s => s.company_db_id == terminal.company_db_id && s.id == terminal.storage_id)
			if (storage) {
				storage.terminals.push(terminal)
				storage.aps.push(terminal.default_cashreg_ap)
			}
		}

		for (const site of sites) {
			site.terminal_count = 0
			for (const storage of site.storages) {
				site.terminal_count += storage.terminals.length
				site.aps.push(...storage.aps)
				delete storage.aps
			}
			site.aps = site.aps.join(', ')
		}

		await Anvil.renderPage('/c_order/terminal/page_map', { sites: { data: sites } })
	}
}
